import { render, staticRenderFns } from "./DocumentItemCardBySupp.vue?vue&type=template&id=1cd7ac5c&scoped=true"
import script from "./DocumentItemCardBySupp.vue?vue&type=script&lang=js"
export * from "./DocumentItemCardBySupp.vue?vue&type=script&lang=js"
import style0 from "./DocumentItemCardBySupp.vue?vue&type=style&index=0&id=1cd7ac5c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cd7ac5c",
  null
  
)

export default component.exports